import * as api from '../lib/api';
import { makeGrowerPath } from '../lib/api/utils';

export function generate(aaids) {
  return api.post(
    makeGrowerPath('/hexbins'),
    aaids.map((aaid) => ({ aaid })),
  );
}
